import { IDataProps } from 'src/app/config/interfaces';
import {
  getActionFactory,
  getAsyncActionFactory,
} from '../../core/redux/utils/action-class-factory';
import {
  IAllOrganizations,
  IGroup,
  IProductInstance,
  IRole,
  IUser,
} from '../../interfaces/ICommon';

const createAction = getActionFactory('COMMON');
const createAsyncAction = getAsyncActionFactory('COMMON');

/* ----------------- async actions ----------------- */
export const FetchAllProductsInstances = createAsyncAction<
  null,
  IProductInstance[]
>('FETCH_ALL_PRODUCTS_INSTANCES');

export const FetchAllUsers = createAsyncAction<null, IUser[]>(
  'FETCH_ALL_USERS'
);

export const FetchAllRoles = createAsyncAction<null, IRole[]>(
  'FETCH_ALL_ROLES'
);

export const FetchAllGroups = createAsyncAction<null, IGroup[]>(
  'FETCH_ALL_GROUPS'
);

export const FetchAllOrganizations = createAsyncAction<null, IAllOrganizations>(
  'FETCH_ALL_ORGANIZATIONS'
);

export const FetchFeatureFlags = createAsyncAction<null, string[]>(
  'FETCH_FEATURE_FLAGS'
);

export const FetchTenantId = createAsyncAction<
  { config: IDataProps },
  string[]
>('FETCH_TENANT_ID');

/* ----------------- sync actions ------------------ */
export const ClickAway = createAction<{
  path?: string;
  shouldRedirect?: boolean;
  signOutCallback?: Function;
}>('CLICK_AWAY');

export const SetBootstrapConfig = createAction<{
  isStandalone: boolean;
  basePath: string | null;
}>('SET_BOOTSTRAP_CONFIG');

export const SetNavigateConfig = createAction<{
  redirectPath: string | null;
  enterpriseId: string | null;
  navigateFn: Function;
}>('SET_NAVIGATE_CONFIG');

export const SetNavigateFn = createAction<Function>('SET_NAVIGATE_FN');

export const CloseErrorBanners = createAction('CLOSE_ERROR_BANNERS');

export const CloseGroupsGeneralNetworkErrorBanner = createAction(
  'CLOSE_GROUPS_GENERAL_NETWORK_ERROR_BANNER'
);
